import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e90014ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container h-full"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Baixa do CNPJ MEI", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "warning-box" }, " Atenção! A baixa/cancelamento de seu MEI é irreversível. Após dado baixa, não é mais possível reativar o CNPJ. Para isso você deverá realizar uma nova abertura e será gerado um novo CNPJ. ", -1))
const _hoisted_4 = { class: "next-step-button" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Continuar", -1))

import { ref } from "vue";
import {
	useIonRouter,
	IonPage,
	IonContent,
	IonIcon,
	toastController,
	onIonViewWillEnter,
} from "@ionic/vue";
import { Form } from "vee-validate";
import { arrowForwardOutline } from "ionicons/icons";

import Input from "@/components/base/Input.vue";
import Button from "@/components/Button.vue";
import BackHeader from "@/components/layouts/BackHeader.vue";
import { step1 } from "@/validations/lowMeiForm";
import { useServiceForm } from "@/composables/serviceForm";
import api from "@/services/api/api";
import { useService } from "@/composables/services";
import { formatDate, removeMask } from "@/helpers/filters";
import { useUser } from "@/composables/user";
import LoadingScreen from "@/components/LoadingScreen.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LowMei',
  setup(__props) {

const ionRouter = useIonRouter();
const { user } = useUser();
const { getByServiceCode, service } = useService();
const { setFormData, clearForm, form } = useServiceForm();

const loading = ref(true);
// const voterRegistration = ref(false);

const onSubmit: any = async (formData: never) => {
	setFormData(formData);
	const allowed = ["cnpj", "voterRegistrationCard"];
	setFormData(removeMask(form.value, allowed));
	await getByServiceCode("LOW_MEI");
	try {
		const { order } = await api.createOrder({
			serviceId: service.value.id,
			serviceCode: service.value.code,
			requestData: form.value,
		});
		return ionRouter.push(`/payments/${order.id}`);
	} catch (error: any) {
		const toast = await toastController.create({
			message: error.message,
			duration: 2000,
			color: "danger",
		});
		await toast.present();
	}
};
const loadData = async () => {
	loading.value = true;
	clearForm();
	if (user.value)
		setFormData({
			cnpj: user.value.cnpj,
			// voterRegistrationCard: user.value.voterRegistrationCard,
			birthDate: formatDate(user.value.birthDate),
		});
	loading.value = false;
};

onIonViewWillEnter(() => {
	loadData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(BackHeader),
      _withDirectives(_createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(LoadingScreen)
        ]),
        _: 1
      }, 512), [
        [_vShow, loading.value]
      ]),
      _withDirectives(_createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          (!loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(Form), {
                  class: "grid gap-y-3 w-full py-10",
                  "validation-schema": _unref(step1),
                  onSubmit: onSubmit
                }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _createVNode(Input, {
                      type: "text",
                      name: "cnpj",
                      placeholder: "CNPJ do MEI *",
                      value: _unref(form)?.cnpj,
                      label: "CNPJ do MEI *",
                      maska: "##.###.###/####-##",
                      disabled: ""
                    }, null, 8, ["value"]),
                    _createVNode(Input, {
                      type: "text",
                      name: "birthDate",
                      placeholder: " __/__/__",
                      label: "Sua data de nascimento:",
                      maska: "##/##/####",
                      value: _unref(form)?.birthDate
                    }, null, 8, ["value"]),
                    _createVNode(Input, {
                      type: "text",
                      name: "motherName",
                      label: "Nome da mãe *",
                      placeholder: "Nome da mãe *"
                    }),
                    _createVNode(Input, {
                      type: "password",
                      name: "govPassword",
                      placeholder: "Sua senha no portal do governo (gov.br)",
                      label: "Sua senha no portal do governo (gov.br)",
                      value: _unref(form)?.capital
                    }, null, 8, ["value"]),
                    _hoisted_3,
                    _createVNode(Button, {
                      type: "submit",
                      class: "w-full",
                      onClick: onSubmit
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _hoisted_5,
                          _createVNode(_unref(IonIcon), { icon: _unref(arrowForwardOutline) }, null, 8, ["icon"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["validation-schema"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512), [
        [_vShow, !loading.value]
      ])
    ]),
    _: 1
  }))
}
}

})